import { Input, Component, OnInit } from "@angular/core";
import { faChartMixed } from "@fortawesome/pro-light-svg-icons";
@Component({
    selector: "app-blank-chart",
    templateUrl: "./blank-chart.component.html",
    styleUrls: ["./blank-chart.component.scss"],
    standalone: false
})
export class BlankChartComponent implements OnInit {
  @Input() type?: string;
  constructor() {}
  faChartMixed = faChartMixed;
  ngOnInit(): void {}
}
